import { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

class Tasks extends Component {
  constructor(props) {
    super(props);
    this.tasks = [];

    this.reloadOrders = this.reloadOrders.bind(this);
    this.updateOrderView = this.updateOrderView.bind(this);
  }

  componentDidMount() {
    this.tasks.push(setInterval(this.updateOrderView, 5000));
    const refreshInterval = moment.duration(30, 'minutes').asMilliseconds();
    this.tasks.push(setInterval(this.reloadOrders, refreshInterval));
  }

  componentWillUnmount() {
    this.tasks.forEach(t => clearInterval(t));
  }

  reloadOrders() {
    if (this.props.loggedIn) {
      this.props.reloadOrders();
    }
  }

  updateOrderView() {
    if (this.props.loggedIn) {
      this.props.updateOrderView();
    }
  }

  render() { return null; }
}

Tasks.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  updateOrderView: PropTypes.func.isRequired,
  reloadOrders: PropTypes.func.isRequired,
};

export default Tasks;

